import { Link } from "react-router-dom";

function ContentLanding() {
  return (
    <div style={{ maxWidth: "850px" }}>
      <div className="all">
        <div className="all__row">
          <div className="all__row__item">
            <div>
              <Link to="/article/et-EE/3/uudis-palmako-muutis-kutuse-hankimise-nahtavamaks-ja-paremini-juhitavaks">
                <img
                  className="all__row__item__img"
                  src="../../../images/png/news-3.png"
                  alt="Img3"
                />
              </Link>
            </div>
            <div className="all__row__item__title">
              <Link
                to="/article/et-EE/3/uudis-palmako-muutis-kutuse-hankimise-nahtavamaks-ja-paremini-juhitavaks"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                UUDIS: Palmako muutis kütuse hankimise nähtavamaks ja paremini juhitavaks
              </Link>
            </div>
            <div className="all__row__item__labelContainer">
              <div className="all__row__item__label">Puidutööstus</div>
              <div className="all__row__item__label">Reaalaja ülevaade</div>
              <div className="all__row__item__label">Varude juhtimine</div>
            </div>
            <div>
              Palmako viis koostöös Turgoiliga lõpule projekti,
              mille eesmärk oli parandada ülevaadet ettevõtte kütusevarudest
              ning vähendada töötajate koormust kütuse hankimise korraldamisel.
            </div>
          </div>
          <div className="all__row__item">
            <div>
              <Link to="/article/et-EE/4/horizon-tselluloosi-ja-paberi-kogemus-automaatiseeritud-kutusehange-muudab-too-kiiremaks-ja-lihtsamaks">
                <img
                  className="all__row__item__img"
                  src="../../../images/png/news-4.png"
                  alt="Img4"
                />
              </Link>
            </div>
            <div className="all__row__item__title">
              <Link
                to="/article/et-EE/4/horizon-tselluloosi-ja-paberi-kogemus-automaatiseeritud-kutusehange-muudab-too-kiiremaks-ja-lihtsamaks"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Horizon Tselluloosi ja Paberi kogemus: automaatne kütusehange muudab töö kiiremaks ja lihtsamaks
              </Link>
            </div>
            <div className="all__row__item__labelContainer">
              <div className="all__row__item__label">Tööstus</div>
              <div className="all__row__item__label">Automatiseerimine</div>
              <div className="all__row__item__label">Tarnekindlus</div>
            </div>
            <div>
              Horizoni Tselluloosi ja Paberi igapäevases tegevuses ja tööstusprotsesside
              toimimises mängib kütus kriitilist rolli. Kuna iga tarneviivitus võib otseselt
              mõjutada tootmise sujuvust, on tarnekindlus ettevõtte jaoks äärmiselt tähtis.
            </div>
          </div>
        </div>
        <div className="all__row">
          <div className="all__row__item">
            <div>
              <Link to="/article/et-EE/1/eesti-killustiku-kogemus-vedelkutuste-hulgiturul-on-revolutsioonihongulised-ajad">
                <img
                  className="all__row__item__img"
                  src="../../../images/png/EK_img1.png"
                  alt="Img1"
                />
              </Link>
            </div>
            <div className="all__row__item__title">
              <Link
                to="/article/et-EE/1/eesti-killustiku-kogemus-vedelkutuste-hulgiturul-on-revolutsioonihongulised-ajad"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Eesti Killustiku kogemus: Vedelkütuste hulgiturul on
                revolutsioonihõngulised ajad
              </Link>
            </div>
            <div className="all__row__item__labelContainer">
              <div className="all__row__item__label">Karjäärid</div>
              <div className="all__row__item__label">Kütusehange</div>
              <div className="all__row__item__label">Läbipaistvus</div>
            </div>
            <div>
              Eesti Killustik OÜ osales vedelkütuste hankeplatvormi Turgoil
              pilootprojektis, mis on karjäärides tegutsevale ettevõttele olnud
              suur võimalus panustada valdkonna uuendustesse ning aidata seeläbi
              muuta kütuseturgu läbipaistvamaks. Konkurentsist tulenev soodne
              kütuse hind on neile olnud meeldivaks boonuseks.
            </div>
          </div>
          <div className="all__row__item">
            <div>
              <Link
                to="/article/et-EE/2/jaagumae-kogemus-turgoili-platvorm-saastab-kutuste-hankimisel-aega-ja-narvikulu"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  className="all__row__item__img"
                  src="../../../images/png/Jaagumae_img1.png"
                  alt="Img1"
                />
              </Link>
            </div>
            <div className="all__row__item__title">
              <Link
                to="/article/et-EE/2/jaagumae-kogemus-turgoili-platvorm-saastab-kutuste-hankimisel-aega-ja-narvikulu"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Jaagumäe kogemus: Turgoili platvorm säästab kütuste
                hankimisel aega ja närvikulu
              </Link>
            </div>
            <div className="all__row__item__labelContainer">
              <div className="all__row__item__label">Põllumajandus</div>
              <div className="all__row__item__label">Kütusehange</div>
              <div className="all__row__item__label">Ajasääst</div>
            </div>
            <div>
              Jaagumäe OÜ peab Turgoili pilootprojektis osalemist igati
              meeldivaks ettevõtmiseks, sest platvorm oli juba alustamise hetkel
              hästi organiseeritud ning kasutajatagasisidet võeti kiireimas
              korras kuulda. Kõik see on soodustanud järgnevate hangete
              korraldamist, mida põllumajanduses tegutsev ettevõte oskab oma
              tööiseloomu arvestades kõrgelt hinnata.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentLanding;
